import React from 'react';
import PropTypes from 'prop-types';
import HeaderSection from '../components/HeaderSection';
import InfoSection from '../components/InfoSection';
import ButtonSection from '../components/ButtonSection';
import { DEFAULT, REMIND } from '../constants';

const Remind = ({ label, labelBtn, loading, onSave, onToggle }) => (
  <div>
    <HeaderSection labelTitle={label.title} labelSubtitle={label.subTitle} />

    <InfoSection
      className="padding-top-1"
      labelTitle={label.remember.title}
      labelDescription={label.remember.description}
    />

    <ButtonSection
      labelCancel={labelBtn.btnCancel}
      labelExec={labelBtn.btnRemindPin}
      loading={loading}
      onToggle={() => onToggle(DEFAULT)}
      onExec={() => onSave(REMIND)}
    />
  </div>
);

Remind.propTypes = {
  label: PropTypes.object,
  labelBtn: PropTypes.object,
  loading: PropTypes.bool,
  onSave: PropTypes.func,
  onToggle: PropTypes.func,
};
export default Remind;
